var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/usertype-new.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-15e962d5!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/usertype-new.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/UserTypeNew.vue
// module id = 760
// module chunks = 1